import { CreativeTagEvent } from '../../enums';
import { CreativeTrackingService } from '../../services/creative-tracking/creative-tracking-service';
import { EntryPoint } from '../../types/player';

export class ExperienceEntryPointTrackingHandler {
  constructor(
    protected experienceEntryPoint: EntryPoint,
    protected creativeTrackingService: CreativeTrackingService
  ) {
    this.attachEventHandlers();
  }

  public sendCreativeInit(): void {
    this.creativeTrackingService.sendCreativeTagTracking(
      CreativeTagEvent.CreativeInit
    );
  }

  private attachEventHandlers() {
    [CreativeTagEvent.CreativeRequested].forEach(eventType => {
      this.experienceEntryPoint.addEventListener(eventType, _ => {
        this.creativeTrackingService.sendCreativeTagTracking(eventType, {
          experience: this.experienceEntryPoint.getExperience()
        });
      });
    });
  }
}
